import { ThaliaLogoFull } from "./ThaliaLogoFull";
export const ThaliaLogo = () => {
	return (
		<div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
			<ThaliaLogoFull />
		</div>
	);
};
